export enum SourceType {
	Library = 1,
	Custom = 2,
}
